import { ListeTable } from '@mairistem/liste';

const ReglementChequeListeTableHeader = (props) => (
  <>
    <ListeTable.Column {...props} name="numeroRecu" style={{ width: 175 }} verticalAlign="middle">
      N° de reçu
    </ListeTable.Column>
    <ListeTable.Column {...props} name="dateRecu" style={{ width: 120 }} verticalAlign="middle">
      Date
    </ListeTable.Column>
    <ListeTable.Column {...props} name="nomPayeur" verticalAlign="middle">
      Nom du payeur
    </ListeTable.Column>
    <ListeTable.Column {...props} name="numero" verticalAlign="middle">
      N° de chèque
    </ListeTable.Column>
    <ListeTable.Column {...props} name="banque" verticalAlign="middle">
      Banque
    </ListeTable.Column>
    <ListeTable.Column {...props} name="tireur" verticalAlign="middle">
      Nom du tireur
    </ListeTable.Column>
    <ListeTable.Column {...props} name="montant" style={{ width: 140 }} verticalAlign="middle">
      Montant
    </ListeTable.Column>
  </>
);

export default ReglementChequeListeTableHeader;
